import { CompoundedMedicationDisclaimer } from "@/features/products/components/compounded-medications-disclaimer";
import { useShopContext } from "@/features/products/context";
import type { CategoryWithProducts } from "@/features/products/models";
import { ProductDetailsModal } from "@/features/products/sections/shop-overview";
import { Heading } from "@/shared/ui";

interface ShopProductsListProps {
  categories: CategoryWithProducts[];
}

export const ShopProductsList = ({ categories }: ShopProductsListProps) => {
  const { selectedCategory } = useShopContext();

  const filteredCategories = selectedCategory
    ? categories.filter((category) => category.slug === selectedCategory)
    : categories;

  return (
    <div className="@container flex flex-col gap-12 lg:px-20">
      {filteredCategories?.map(({ id, name, products }) => (
        <section key={`section-${id}`} className="flex flex-col gap-4">
          {filteredCategories.length > 1 && (
            <div className="inline-flex items-center gap-4">
              <Heading level={2} size="x-small" color="primary">
                {name}
              </Heading>

              <hr className="grow border-primary-950" />
            </div>
          )}

          <div className="grid grid-cols-2 gap-4 @5xl:grid-cols-3">
            {products?.map((product) => (
              <ProductDetailsModal key={product.id} product={product} />
            ))}
          </div>
        </section>
      ))}
      <CompoundedMedicationDisclaimer />
    </div>
  );
};
